import { atomWithStorage } from 'jotai/utils';
import { useAtom } from 'jotai';

/**
 * Sections default OPEN, so only a deliberate collapse needs to be
 * remembered — an absent key means "open", never a missing preference.
 */
const collapsedSectionsAtom = atomWithStorage<Record<string, boolean>>(
  'mfw-sidebar-collapsed-sections',
  {},
);

export function useSidebarSectionCollapse(persistKey: string) {
  const [collapsedSections, setCollapsedSections] = useAtom(
    collapsedSectionsAtom,
  );
  const isOpen = !collapsedSections[persistKey];

  const toggle = () => {
    setCollapsedSections((prev) => ({
      ...prev,
      [persistKey]: !prev[persistKey],
    }));
  };

  return { isOpen, toggle };
}
